import React from 'react'
import { CustomButton } from 'components/ui'
import { useUpdateMatriculaByProject } from 'lib/react-query/queriesModuloType'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { IconCode } from 'lib/icons/Icon'
import { Tooltip } from 'react-tooltip'

const ConfigMatriculasRow = ({ matricula, isFetching }) => {
  const { mutate } = useUpdateMatriculaByProject()

  const handleVisibility = () => {
    mutate({
      id: matricula._id,
      body: {
        visible: !matricula.visible,
      },
    })
  }

  return (
    <tr
      style={{ background: !matricula.visible && '#ededed' }}
      className="row-align-config-matriculas"
    >
      <td className="name-row-config-matriculas-table">
        <IconCode />
        {matricula.code}
      </td>
      <td className="ta-right">
        <Tooltip
          // anchorSelect=".button-config-matriculas-table"
          id={`my-tooltip-${matricula._id}`}

          style={{ zIndex: 99999999, fontSize: '10px' }}
        >
          {matricula.visible ? 'Ocultar' : 'Mostrar'}
        </Tooltip>

        <CustomButton
          className="button-config-matriculas-table"
          type="secondary"
          onClick={handleVisibility}
          disabled={isFetching}
          data-tooltip-id={`my-tooltip-${matricula._id}`}
        >
          {matricula.visible ? (
            <RemoveRedEyeIcon />
          ) : (
            <VisibilityOffIcon style={{ color: 'grey' }} />
          )}
        </CustomButton>
      </td>
    </tr>
  )
}

export default ConfigMatriculasRow
